import styled from 'styled-components';

import { ButtonSize, ButtonVariant } from '../Button';
import { StyledButton } from '../Button/styled';

interface IChipProps {
    checked: boolean;
}

export const Chip = styled(StyledButton).attrs<IChipProps>(({ checked }) => ({
    size: ButtonSize.SMALL,
    variant: checked ? ButtonVariant.PRIMARY : ButtonVariant.SECONDARY,
    type: 'button',
    'aria-selected': checked,
}))<IChipProps>`
    font-weight: 400;
    user-select: none;
`;
